import { weekGoalError } from "@/lib/points";
import type { RecurringTasksConfig } from "@/lib/schema";
import type { WidgetValidationResult } from "@/widgets/types";
import { maxScoreWeek } from "./scoring";

export function validate(config: RecurringTasksConfig): WidgetValidationResult {
  const errors: Record<string, string> = {};
  if (config.label.trim().length === 0) {
    errors.label = "Etikett kan ikke være tom.";
  }
  if (config.points < 1) {
    errors.points = "Poeng må være minst 1.";
  }
  // The one kind that accepts a goal of 0 — an instance that scores without
  // aiming at anything.
  const goalError = weekGoalError(config.weekGoal, {
    max: maxScoreWeek(config),
    allowZero: true,
  });
  if (goalError) errors.weekGoal = goalError;
  if (config.tasks.length === 0) {
    errors.tasks = "Minst én oppgave kreves.";
  } else {
    // Weekly tasks carry a single `checkableFrom` day that is always set, so
    // only the daily mode's day sets can be empty.
    if (config.reset === "daily") {
      const hasVisible = config.tasks.some((t) => t.visibleDays.length > 0);
      if (!hasVisible) {
        errors.tasks = "Minst én oppgave må være synlig på minst én dag.";
      }
    }
    const hasEmptyLabel = config.tasks.some((t) => t.label.trim().length === 0);
    if (hasEmptyLabel) {
      errors.taskLabels = "Alle oppgaver må ha et navn.";
    }
  }
  if (Object.keys(errors).length === 0) return { ok: true };
  return { ok: false, errors };
}
